<h1 mat-dialog-title>Confirmación</h1>
<div mat-dialog-content>
    <p>{{ data.question }}</p>
</div>
<div mat-dialog-actions>
    <button mat-raised-button color="accent" (click)="onNoClick()" tabindex="2">No</button>
    <button mat-raised-button color="primary" (click)="onYesClick()" (keydown.enter)="onYesClick()" tabindex="1">Si</button>
</div>
